import React from "react";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step31 from "./Step3_1";
import Step4 from "./Step4";

const Pages = ({ indexProgress = 0 }) => {
  const switchPage = [<Step1 />, <Step2 />, <Step3 />,  <Step31 />,<Step4 />];
  return (
    <div>
      <div className="">{switchPage[indexProgress]}</div>
    </div>
  );
};

export default Pages;
